import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route
                        path="/confidentialite"
                        element={<LegalPage slug="confidentialite" />}
                    />
                    <Route
                        path="/mentions-legales"
                        element={<LegalPage slug="mentions-legales" />}
                    />
                    <Route path="/cgu" element={<LegalPage slug="cgu" />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </div>
    );
}

export default App;
